import queryString from "query-string";
import { TEAM_IDS, USER_IDS } from "../../../constants/filters";
import { GetIdsList } from "../../../assets/convertUrlFilter";

export const GetFilter = () => {
  let filters = queryString.parse(document.location.search);
  return filtersNormalize(filters);
};

const filtersNormalize = filters => {
  return {
    [USER_IDS]: GetIdsList(filters[USER_IDS]),
    [TEAM_IDS]: GetIdsList(filters[TEAM_IDS])
  };
};
